import {UserRightsVO} from '../api';
import {LayerId} from '@mc/react-mapio';
import {AuthData} from '@mc/react-auth';

export const ROLE_MAPIO_ADMIN = 'MAPIO_ADMIN';

export const isLayerVlastnik = (userRights: UserRightsVO, layerId: LayerId): boolean => {
    if (!userRights || !userRights.layers) {
        return false;
    }

    const layerRights = userRights.layers.find(layerRight => layerRight.layer?.id === layerId);

    return !!layerRights?.vlastnikVrstvy;
};

export const isVlastnikOfAllLayers = (userRights: UserRightsVO, layerIds: LayerId[]): boolean => {
    if (!userRights || !userRights.layers || layerIds.length === 0) {
        return false;
    }
    return layerIds.every(layerId => {
        const layerRight = userRights.layers.find(lr => lr.layer?.id === layerId);
        return !!layerRight?.vlastnikVrstvy;
    });
};

/**
 * Vrátí true pokud je uživatel Administrátor, Administrátor konfigurace Mapio nebo má admin oprávnění.
 */
export const isUserAdminOrMapioAdmin = (auth: AuthData): boolean => {
    if (!auth) return false;
    if (auth.admin) return true;
    return auth.roleUzivatele?.some(r => r.kod === ROLE_MAPIO_ADMIN) ?? false;
};
